package one.healthium.insights.ui.personal_mealplan

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.horizontalScroll
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.unit.dp
import loco.CONTENT_PERSONAL_MEAL_PLAN_DAY_FORMAT
import one.healthium.ui.compose.theme.AppTheme
import one.healthium.ui.compose.theme.gray_3
import org.jetbrains.compose.resources.stringResource

@Composable
internal fun DaySelector(
    modifier: Modifier = Modifier,
    dayCount: Int,
    selectedIndex: Int,
    onDaySelected: (Int) -> Unit,
) {
    Row(
        modifier = modifier
            .fillMaxWidth()
            .horizontalScroll(rememberScrollState())
            .padding(horizontal = 16.dp),
        horizontalArrangement = Arrangement.spacedBy(6.dp),
    ) {
        for (i in 0 until dayCount) {
            val isSelected = i == selectedIndex
            val dayNumber = (i + 1).toString().padStart(2, '0')
            DayChip(
                label = stringResource(loco.Res.string.CONTENT_PERSONAL_MEAL_PLAN_DAY_FORMAT, dayNumber),
                isSelected = isSelected,
                onClick = { onDaySelected(i) },
            )
        }
    }
}

@Composable
private fun DayChip(
    modifier: Modifier = Modifier,
    label: String,
    isSelected: Boolean,
    onClick: () -> Unit,
) {
    val backgroundColor = if (isSelected) AppTheme.colors.secondary else AppTheme.colors.surface
    val textColor = if (isSelected) AppTheme.colors.textInverted100 else gray_3

    Box(
        modifier = modifier
            .clip(RoundedCornerShape(48.dp))
            .background(backgroundColor)
            .clickable(onClick = onClick)
            .padding(horizontal = 16.dp, vertical = 9.dp),
        contentAlignment = Alignment.Center,
    ) {
        Text(
            text = label,
            style = AppTheme.textStyles.secondary_14_500,
            color = textColor,
        )
    }
}

// --- Previews ---

@Preview(showBackground = true)
@Composable
private fun DaySelectorPreview() {
    AppTheme {
        DaySelector(dayCount = 7, selectedIndex = 2, onDaySelected = {})
    }
}

@Preview(showBackground = true)
@Composable
private fun DayChipSelectedPreview() {
    AppTheme {
        DayChip(label = "Day 03", isSelected = true, onClick = {})
    }
}

@Preview(showBackground = true)
@Composable
private fun DayChipUnselectedPreview() {
    AppTheme {
        DayChip(label = "Day 03", isSelected = false, onClick = {})
    }
}
